var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0483 5.68277C14.5379 4.20763 12.3679 3.41156 9.99993 3.41156C7.44 3.41156 5.16671 4.18016 3.66379 5.73407C3.2874 5.80982 2.91937 5.91742 2.56351 6.05515C4.24644 3.99464 6.86118 2.85156 9.99993 2.85156C13.187 2.85156 15.7966 3.99825 17.4653 6.06654C17.0102 5.88797 16.5351 5.75888 16.0483 5.68277Z",
    stroke: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 16.8516H15C16.1935 16.8516 17.3381 16.3775 18.182 15.5335C19.0259 14.6896 19.5 13.545 19.5 12.3516C19.5 11.1581 19.0259 10.0135 18.182 9.16958C17.3381 8.32567 16.1935 7.85156 15 7.85156H5.00005H5.00002C4.2628 7.85152 3.53686 8.0326 2.88603 8.37889C2.23519 8.72518 1.67941 9.22606 1.26754 9.8375C0.855663 10.4489 0.600322 11.1522 0.523961 11.8855C0.447601 12.6187 0.552561 13.3595 0.829613 14.0427C1.10667 14.7259 1.54732 15.3305 2.11284 15.8035C2.67836 16.2764 3.35141 16.6032 4.07282 16.7551C4.79424 16.9069 5.54191 16.8792 6.2501 16.6744C6.95716 16.4699 7.60324 16.095 8.13173 15.5828L8.15674 15.5578L8.18524 15.5364C8.32006 15.4354 8.46469 15.3482 8.61695 15.2761C8.93047 15.127 9.39614 14.977 9.99717 14.9766C9.99813 14.9766 9.99909 14.9766 10 14.9766V15.4766C10.4039 15.4719 10.8037 15.5578 11.17 15.7278L14.9995 16.8516ZM14.9995 16.8516C13.8304 16.8529 12.7071 16.3977 11.8687 15.5831M14.9995 16.8516L11.8687 15.5831M11.8687 15.5831L11.8686 15.583C11.8686 15.583 11.8687 15.5831 11.8687 15.5831Z",
    stroke: "#404041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractive);
export default __webpack_public_path__ + "static/media/Interactive.5ca06d2e8d6c22330121466a33fc23f2.svg";
export { ForwardRef as ReactComponent };